export default __webpack_public_path__ + "static/media/X.e72d1369.png";